module.exports = __webpack_public_path__ + "media/thumbnails/face-style-3-a5a7bb1f.svg";